// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1KjTU","label":"SetPasswdForm_label__3bKJ3"};